"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeVideoUrlWithFragment = void 0;
// Need just for the base URL to resolve relative URLs on the server-side, it can be any anything
const baseUrl = 'https://dummy.com';
const tParamRegex = /(^|[#&?])t=/;
/**
 * Adds the hash fragment #t=0.001 to the URL if it's not already present.
 * Preserves the original URL format (relative or absolute).
 *
 * @param inputUrl - original video URL (can be relative or absolute)
 * @param base - base URL for resolving relative URLs (useful on server-side)
 * @returns the adjusted URL with the #t=0.001 fragment or original if invalid
 */
const normalizeVideoUrlWithFragment = inputUrl => {
  try {
    const url = new URL(inputUrl, baseUrl);
    const alreadyHasVideoFragment = tParamRegex.test(url.hash);
    if (!alreadyHasVideoFragment) {
      url.hash = url.hash ? `${url.hash}&t=0.001` : '#t=0.001';
    }
    const isAbsolute = inputUrl.startsWith('http://') || inputUrl.startsWith('https://');
    return isAbsolute ? url.toString() : `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return inputUrl;
  }
};
exports.normalizeVideoUrlWithFragment = normalizeVideoUrlWithFragment;
